<template>
    <div class="flex flex-column justify-content-center align-items-center outer-box">
        <div class="flex flex-column justify-content-center align-items-center main-page-box">
            <div style="padding:0 0 20px 0">Brak dostępu!</div>
            <div class="page-name">{{ name }}</div>
        </div>
        <div>
            <Image :src="noPermissionLogo" />
        </div>

    </div>
</template>

<script setup>
import Image from '@helper/Image.vue'
import { noPermissionLogo } from '@helper/constants.js'

const props = defineProps({
    name: String,
})

</script>

<style scoped>
.outer-box {
    width: 100%;
    height: calc(100vh - 127px);
}

.main-page-box {
    width: 850px;
    height: 350px;
    font-size: 36px;
    background-color: rgba(255, 255, 255, 1);
    margin: 15px;
    padding: 10px 15px;
    color: #000;
    border-radius: 10px;
    box-shadow: 0px 29px 52px 0px rgba(0, 0, 0, 0.4),
        0px 25px 16px 0px rgba(0, 0, 0, 0.2);
}

.page-name {
    font-size: 36px;
    color: #154A9A
}
</style>
